import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Truck, Award } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50/40"
    >
      <div aria-hidden className="pointer-events-none absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-blue-200/40 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -bottom-40 -left-20 w-[420px] h-[420px] rounded-full bg-emerald-200/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-24 md:pt-28 md:pb-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-medium tracking-wider uppercase mb-7">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            Established 2013 · Trusted Nationwide
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-slate-900 leading-[1.05]">
            A Legacy of Management Excellence,{" "}
            <span className="gradient-text-blue">A Future of Dynamic Trade</span>
          </h1>

          <p className="mt-7 text-lg text-slate-600 leading-relaxed max-w-2xl">
            High Roller Consumer Goods Trading is the preferred choice of customers and the most reliable regional partner for suppliers — distributing high-quality, fast-moving consumer goods across the Philippines.
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-view-products"
              onClick={() => scrollTo("products")}
              className="group inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-7 py-3.5 font-medium transition-colors shadow-md shadow-blue-600/20"
            >
              View Products
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-contact"
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center gap-2 border-2 border-slate-200 hover:border-slate-300 text-slate-900 rounded-full px-7 py-3.5 font-medium hover:bg-slate-50 transition-colors"
            >
              Contact Us
            </button>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
            {[
              { Icon: ShieldCheck, label: "Quality Brands", value: "100+" },
              { Icon: Truck, label: "Distribution Reach", value: "Nationwide" },
              { Icon: Award, label: "Years in Trade", value: "12+" },
            ].map(({ Icon, label, value }) => (
              <div key={label} className="flex items-start gap-3">
                <span className="shrink-0 w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center">
                  <Icon size={18} />
                </span>
                <div>
                  <div className="font-heading text-xl font-semibold text-slate-900">{value}</div>
                  <div className="text-xs text-slate-500">{label}</div>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
